const getBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:5000";
    }
    return window.location.origin;
  }
  return "http://localhost:5000";
};

const BASE_URL = getBaseUrl();
const API_BASE = `${BASE_URL}/api`;

export const API_ENDPOINTS = {
  BASE_URL,
  API_BASE,

  // Auth & Profile
  LOGIN: `${API_BASE}/admin/login`,
  USER_LOGIN: `${API_BASE}/auth`,
  ADMIN_PROFILE: `${API_BASE}/admin/profile`,
  USER_PROFILE: `${API_BASE}/user`,
  USER_ALL: `${API_BASE}/user/all`,

  // Core CMS Modules
  ABOUT: `${API_BASE}/about`,
  CONTACT: `${API_BASE}/contact`,
  DONATIONS: `${API_BASE}/donations`,
  FESTIVALS: `${API_BASE}/festivals`,
  GALLERY: `${API_BASE}/gallery`,
  HOME: `${API_BASE}/home`,
  IDOL: `${API_BASE}/idol`,
  SPIRITUAL_LINKS: `${API_BASE}/spiritual-links`,
  LIVE_DARSHAN: `${API_BASE}/live-darshan`,
  POOJAS: `${API_BASE}/poojas`,
  POOJAS_UPLOAD: `${API_BASE}/poojas/upload`,
  TIMINGS: `${API_BASE}/timings`,
  UPLOAD: `${API_BASE}/upload`,

  // Nakshatra Homam
  HOMAM_REGISTER: `${API_BASE}/homam/register`,
  HOMAM_BOOKINGS: `${API_BASE}/homam/bookings`,
  HOMAM_EXPORT: `${API_BASE}/homam/export`,
  HOMAM_SETTINGS: `${API_BASE}/homam/settings`,
  HOMAM_PAYMENT: (id) => `${API_BASE}/homam/bookings/${id}/payment`,
  HOMAM_VERIFY_PAYMENT: (id) => `${API_BASE}/homam/bookings/${id}/verify-payment`,
};

